import { ConditionalResult } from './ConditionalResult';
import { MapResult } from './MapResult';
import { DateResult } from './DateResult';
export var logic = {
    ConditionalResult: ConditionalResult,
    MapResult: MapResult,
    DateResult: DateResult,
};
